import './index.css'; 

interface ContactInfoButtonProps {
  icon: string; 
  title: string;
  subtitle: string;
  onClick?: () => void;
}

const ContactInfoButton: React.FC<ContactInfoButtonProps> = ({
  icon,
  title,
  subtitle,
  onClick,
}) => {
  return (
    <button className="email-button">
      <div className="email-icon">
        <img src={icon} alt={title} />
      </div>
      <div className="email-text">
        <div className="email-title">{title}</div>
        <div className="email-subtitle">{subtitle}</div>
      </div>
    </button>
  );
};

export default ContactInfoButton;